import { useNavigate } from "react-router-dom";
import { useLogout } from "@/hooks/mutations/use-logout";
import { ThemeSwitcher } from "./theme-switcher";
import { Button } from "./ui/button";
import { Card, CardHeader } from "./ui/card";

export function Navbar() {
	const { mutate } = useLogout();
	const navigate = useNavigate();

	const handleLogout = () => {
		mutate(undefined, {
			onSuccess: () => {
				navigate("/login");
			},
		});
	};

	return (
		<Card className="mb-2 bg-transparent py-2">
			<CardHeader className="flex justify-between items-center">
				<h1 className="text-lg">IED Control Panel</h1>
				<div className="flex items-center gap-2">
					<ThemeSwitcher />
					<Button onClick={handleLogout}>Logout</Button>
				</div>
			</CardHeader>
		</Card>
	);
}
